<template>
  <div>
    <v-layout v-if="!footerHide && !shareButtonHide" row wrap justify-center>
      <v-flex xs12 class="text-xs-center">
        <p class="d-inline-block">
          <span :class="$style.shareIcon" class="px-3 body-1">
            {{ lang.share }}
          </span>
        </p>
        <div class="d-inline-block">
          <vc-share-twitter-share-icon
            :twitter-text="twitterText"
            :twitter-hash-tags="twitterHashTags"
            :src-url="srcUrl"
            icon-size="40px"
            image-type="footer"
            :image-class="[
              $style.shareIcon,
              {
                'mr-3': $vuetify.breakpoint.smAndUp,
                'mr-2': $vuetify.breakpoint.xsOnly
              }
            ]"
          ></vc-share-twitter-share-icon>

          <vc-share-hatena-share-icon
            :src-url="srcUrl"
            icon-size="40px"
            image-type="footer"
            :image-class="[
              $style.shareIcon,
              {
                'mr-3': $vuetify.breakpoint.smAndUp,
                'mr-2': $vuetify.breakpoint.xsOnly
              }
            ]"
            v-if="showJapaneseWebSite"
          ></vc-share-hatena-share-icon>

          <vc-share-facebook-share-icon
            :src-url="srcUrl"
            icon-size="40px"
            image-type="footer"
            :image-class="[
              $style.shareIcon,
              {
                'mr-3': $vuetify.breakpoint.smAndUp,
                'mr-2': $vuetify.breakpoint.xsOnly
              }
            ]"
          ></vc-share-facebook-share-icon>

          <vc-share-line-share-icon
            :line-text="lineText"
            :src-url="srcUrl"
            icon-size="40px"
            image-type="footer"
            :image-class="[
              $style.shareIcon,
              {
                'mr-3': $vuetify.breakpoint.smAndUp,
                'mr-2': $vuetify.breakpoint.xsOnly
              }
            ]"
            v-if="showJapaneseWebSite"
          ></vc-share-line-share-icon>
        </div>
      </v-flex>
    </v-layout>
    <v-footer height="auto">
      <v-card flat tile class="flex grey darken-3 white--text">
        <v-container grid-list-xl>
          <template v-if="!footerHide">
            <v-layout
              row
              wrap
              justify-center
              :class="{ 'ml-5': $vuetify.breakpoint.mdAndUp }"
            >
              <v-flex xs12 sm12 md4 lg3 xl2>
                <v-flex
                  xs9
                  offset-xs1
                  sm6
                  offset-sm3
                  md12
                  offset-md0
                  :class="{ 'pl-5': $vuetify.breakpoint.smOnly }"
                >
                  <h4 class="title pb-2 grey--text">
                    {{ lang.menu_services }}
                  </h4>
                  <ul :class="$style.footerList" class="pl-2">
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_services_clipstudio_start_url"
                        :target="isIce && isIpadIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ dev.menu_services_clipstudio_start }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_services_clipstudio_assets_url"
                        :target="isIce && isIpadIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_services_clipstudio_assets }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_services_clipstudio_tips_url"
                        :target="isIce && isIpadIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_services_clipstudio_tips }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_services_clipstudio_ask_url"
                        :target="isIce && isIpadIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_services_clipstudio_ask }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_services_clipstudio_share_url"
                        :target="isIce && isIpadIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_services_clipstudio_share }}
                        </span>
                      </vc-share-a>
                    </li>
                    <template v-if="locale === 'ja-jp'">
                      <li>
                        <vc-share-a
                          :class="$style.footerListItem"
                          :href="dev.menu_services_clipstudio_mono_url"
                          :target="isIce && isIpadIce ? '_blank' : '_self'"
                        >
                          <span class="white--text">
                            {{ lang.menu_services_clipstudio_mono }}
                          </span>
                        </vc-share-a>
                      </li>
                    </template>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_services_clipstudio_net_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_services_clipstudio_net }}
                        </span>
                      </vc-share-a>
                    </li>
                    <template v-if="locale === 'ja-jp'">
                      <li>
                        <vc-share-a
                          :class="$style.footerListItem"
                          :href="dev.menu_services_oekaki_url"
                          :target="isIce ? '_blank' : '_self'"
                        >
                          <span class="white--text">
                            {{ lang.menu_services_oekaki }}
                          </span>
                        </vc-share-a>
                      </li>
                    </template>
                  </ul>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg3 xl2>
                <v-flex
                  xs9
                  offset-xs1
                  sm6
                  offset-sm3
                  md12
                  offset-md0
                  :class="{ 'pl-5': $vuetify.breakpoint.smOnly }"
                >
                  <div class="d-inline-block">
                    <h4 class="title pb-2 grey--text">{{ lang.menu_sns }}</h4>
                    <v-responsive max-width="100%" class="d-inline-flex">
                      <vc-share-a
                        :href="dev.twitter_follow_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <v-img
                          :class="[
                            $style.followIconSize,
                            'd-inline-block',
                            'ml-2'
                          ]"
                          :src="twitterFollowIcon"
                          alt="twitter_follow_icon"
                        ></v-img>
                      </vc-share-a>
                      <vc-share-a
                        :href="dev.facebook_follow_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <v-img
                          :class="[
                            $style.followIconSize,
                            'd-inline-block',
                            'ml-2'
                          ]"
                          :src="facebookFollowIcon"
                          alt="facebook_follow_icon"
                        ></v-img>
                      </vc-share-a>
                      <vc-share-a
                        :href="dev.instagram_follow_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <v-img
                          :class="[
                            $style.followIconSize,
                            'd-inline-block',
                            'ml-2'
                          ]"
                          :src="instagramFollowIcon"
                          alt="instagram_follow_icon"
                        ></v-img>
                      </vc-share-a>
                      <vc-share-a
                        :href="dev.menu_services_youtube_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <v-img
                          :class="[
                            $style.followIconSize,
                            'd-inline-block',
                            'ml-2'
                          ]"
                          :src="youtubeFollowIcon"
                          alt="youtube_follow_icon"
                        ></v-img>
                      </vc-share-a>

                      <template v-if="locale === 'ja-jp'">
                        <vc-share-a
                          :href="
                            'https://www.tiktok.com/@clipstudioofficial_jp'
                          "
                          :target="isIce ? '_blank' : '_self'"
                        >
                          <v-img
                            :class="[
                              $style.followIconSize,
                              'd-inline-block',
                              'ml-2'
                            ]"
                            :src="tiktokFollowIcon"
                            alt="TikTok_follow_icon"
                          ></v-img>
                        </vc-share-a>
                      </template>
                      <template v-else>
                        <vc-share-a
                          :href="'https://www.tiktok.com/@clipstudioofficial'"
                          :target="isIce ? '_blank' : '_self'"
                        >
                          <v-img
                            :class="[
                              $style.followIconSize,
                              'd-inline-block',
                              'ml-2'
                            ]"
                            :src="tiktokFollowIcon"
                            alt="TikTok_follow_icon"
                          ></v-img>
                        </vc-share-a>
                      </template>
                    </v-responsive>
                  </div>
                </v-flex>
                <v-flex
                  xs9
                  offset-xs1
                  sm6
                  offset-sm3
                  md12
                  offset-md0
                  :class="{ 'pl-5': $vuetify.breakpoint.smOnly }"
                  v-if="!isIce"
                >
                  <h4 class="title pb-2 grey--text">{{ lang.menu_locale }}</h4>
                  <v-menu
                    class="pl-2"
                    top
                    dark
                    origin="center center"
                    transition="scale-transition"
                  >
                    <v-btn
                      slot="activator"
                      outline
                      large
                      :style="{ 'text-transform': 'none' }"
                      color="white"
                    >
                      <v-icon class="pr-2">fas fa-globe-asia</v-icon>
                      {{ lang["locale_menu_" + this.display_locale_text] }}
                    </v-btn>

                    <v-list>
                      <v-list-tile @click="changeLocale('de-de')">
                        <v-list-tile-title class="text-xs-center">
                          {{ lang.locale_menu_de_de }}
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeLocale('en-us')">
                        <v-list-tile-title class="text-xs-center">
                          {{ lang.locale_menu_en_us }}
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeLocale('es-es')">
                        <v-list-tile-title class="text-xs-center">
                          {{ lang.locale_menu_es_es }}
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeLocale('fr-fr')">
                        <v-list-tile-title class="text-xs-center">
                          {{ lang.locale_menu_fr_fr }}
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeLocale('ja-jp')">
                        <v-list-tile-title class="text-xs-center">
                          {{ lang.locale_menu_ja_jp }}
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeLocale('zh-tw')">
                        <v-list-tile-title class="text-xs-center">
                          {{ lang.locale_menu_zh_tw }}
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeLocale('ko-kr')">
                        <v-list-tile-title class="text-xs-center">
                          {{ lang.locale_menu_ko_kr }}
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-flex>
              </v-flex>

              <v-flex xs12 sm12 md4 lg3 xl2>
                <v-flex
                  xs9
                  offset-xs1
                  sm6
                  offset-sm3
                  md12
                  offset-md0
                  :class="{ 'pl-5': $vuetify.breakpoint.smOnly }"
                >
                  <h4 class="title pb-2 grey--text">{{ lang.menu_support }}</h4>
                  <ul :class="$style.footerList" class="pl-2">
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="'/' + locale + '/help'"
                        target="_self"
                      >
                        <span class="white--text">
                          {{ lang.menu_support_about }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="accountUriBase + '/terms?ui_locales=' + locale"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_support_terms_of_use }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.privacy_policy_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_support_privacy_policy }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.support_copyright_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_support_copyright }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_support_maintenance_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ dev.menu_support_maintenance }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.support_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_support_support }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li v-if="locale === 'de-de'">
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.cancel_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ dev.menu_support_cancel }}
                        </span>
                      </vc-share-a>
                    </li>
                  </ul>
                </v-flex>
                <v-flex
                  xs9
                  offset-xs1
                  sm6
                  offset-sm3
                  md12
                  offset-md0
                  :class="{ 'pl-5': $vuetify.breakpoint.smOnly }"
                >
                  <h4 class="title pb-2 grey--text">{{ lang.menu_aboutus }}</h4>
                  <ul :class="$style.footerList" class="pl-2">
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_aboutus_celsys_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_aboutus_celsys }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_aboutus_clipstudio_solution_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_aboutus_clipstudio_solution }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_aboutus_ebook_solution_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_aboutus_ebook_solution }}
                        </span>
                      </vc-share-a>
                    </li>
                    <li>
                      <vc-share-a
                        :class="$style.footerListItem"
                        :href="dev.menu_aboutus_employment_url"
                        :target="isIce ? '_blank' : '_self'"
                      >
                        <span class="white--text">
                          {{ lang.menu_aboutus_employment }}
                        </span>
                      </vc-share-a>
                    </li>
                  </ul>
                </v-flex>
              </v-flex>
            </v-layout>
          </template>
        </v-container>
        <template v-if="!footerHide">
          <v-card
            flat
            tile
            text-md-center
            class="flex blue-grey lighten-3 white--text"
          >
            <v-flex xs12 class="text-xs-center">
              <div
                style="display: flex; justify-content: center; align-items: center;"
              >
                <img
                  src="/view/img/brand/logo_new_celsys.png"
                  alt="CELSYS LOGO"
                  style="width: 70px"
                />
                <div>
                  &copy; {{ new Date().getFullYear() }} CELSYS,Inc. [
                  <vc-share-a
                    :class="[$style.footerListItem, 'white--text']"
                    :href="dev.about_us_url"
                    :target="isIce ? '_blank' : '_self'"
                  >
                    About Us
                  </vc-share-a>
                  ]
                </div>
              </div>
            </v-flex>
          </v-card>
        </template>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "vc-share-footer",
  props: {
    locale: {
      type: String,
      required: true,
      default: ""
    },
    twitterText: {
      type: String,
      default: ""
    },
    twitterHashTags: {
      type: String,
      default: ""
    },
    lineText: {
      type: String,
      default: ""
    },
    srcUrl: {
      type: String,
      default: ""
    },
    isIce: {
      type: Boolean,
      default: false
    },
    isIpadIce: {
      type: Boolean,
      default: false
    },
    showJapaneseWebSite: {
      type: Boolean,
      default: true
    },
    lang: {
      type: Object,
      default: () => {
        return {
          share: "シェアする",
          menu_support: "サポート",
          menu_support_about: "このサービスについて",
          menu_support_terms_of_use: "利用規約",
          menu_support_privacy_policy: "プライバシーポリシー",
          menu_support_copyright: "著作権と商標について",
          menu_support_maintenance: "障害・メンテナンス情報",
          menu_support_support: "サポート・お問い合わせ",
          menu_support_cancel: "Vertrag hier beenden",
          menu_sns: "オフィシャルSNS",
          menu_sns_twitter_follow: "twitterでフォロー",
          menu_sns_facebook_follow: "facebookでフォロー",
          menu_locale: "言語",
          menu_services: "サービス",
          menu_services_clipstudio_profile: "CLIP STUDIO PROFILE",
          menu_services_clipstudio_assets: "CLIP STUDIO ASSETS",
          menu_services_clipstudio_ask: "CLIP STUDIO ASK",
          menu_services_clipstudio_tips: "CLIP STUDIO TIPS",
          menu_services_clipstudio_share: "CLIP STUDIO SHARE",
          menu_services_clipstudio_mono: "CLIP STUDIO MONO",
          menu_services_clip: "創作応援サイト「CLIP STUDIO」",
          menu_services_clipstudio_net: "CLIP STUDIO.net",
          menu_services_oekaki: "イラスト・マンガ描き方ナビ",
          menu_aboutus: "セルシスについて",
          menu_aboutus_celsys: "株式会社セルシス",
          menu_aboutus_clipstudio_solution: "CLIP STUDIO ソリューション",
          menu_aboutus_ebook_solution: "電子書籍ソリューション",
          menu_aboutus_employment: "採用情報",
          locale_menu_ja_jp: "日本語FIX",
          locale_menu_en_us: "English",
          locale_menu_ko_kr: "한국어",
          locale_menu_zh_tw: "繁體中文",
          locale_menu_fr_fr: "Français",
          locale_menu_es_es: "Español",
          locale_menu_de_de: "Deutsch",
          locale_menu_th_th: "English",
          locale_menu_id_id: "English",
          locale_menu_pt_br: "English",
          locale_menu_zh_cn: "English"
        };
      }
    },
    footerHide: {
      type: Boolean,
      default: false
    },
    dev: {
      type: Object,
      default: () => {
        return {
          menu_services_clipstudio_profile_url:
            "https://profile.clip-studio.com/ja-jp",
          menu_services_clipstudio_assets_url:
            "https://assets.clip-studio.com/ja-jp",
          menu_services_clipstudio_ask_url: "https://ask.clip-studio.com/ja-jp",
          menu_services_clipstudio_tips_url:
            "https://tips.clip-studio.com/ja-jp",
          menu_services_clipstudio_share_url:
            "https://share.clip-studio.com/ja-jp",
          menu_services_clipstudio_mono_url:
            "https://mono.clip-studio.com/ja-jp",
          menu_services_clip_site: "https://www.clip-studio.com/clip_site",
          menu_services_clipstudio_net_url: "https://www.clipstudio.net/",
          menu_services_oekaki_url: "https://www.clipstudio.net/oekaki/",
          menu_services_youtube_url:
            "https://www.youtube.com/CLIPSTUDIOchannel",
          menu_services_clipstudio_start_url:
            "https://start.clip-studio.com/ja-jp",

          twitter_follow_url: "https://twitter.com/clip_celsys",
          facebook_follow_url:
            "https://www.facebook.com/celsys.clipstudiopaint/",
          instagram_follow_url: "https://Instagram.com/clipstudioofficial/",

          privacy_policy_url: "https://www.celsys.com/information/privacy/",
          support_copyright_url: "https://www.celsys.com/information/legal/",
          support_url:
            "https://www.clip-studio.com/clip_site/support/support_top/index",
          cancel_url: "https://ec.clip-studio.com/de-de/inquiry/cancel",
          menu_aboutus_celsys_url: "https://www.celsys.com/",
          menu_aboutus_clipstudio_solution_url:
            "https://www.celsys.com/clipsolution/",
          menu_aboutus_ebook_solution_url:
            "https://www.celsys.com/e-booksolution/",
          menu_aboutus_employment_url: "https://www.celsys.com/employment/",

          menu_services_clipstudio_start: "CLIP STUDIO START",
          menu_support_maintenance_url: "https://status.clipstudio.com/"
        };
      }
    },
    accountUriBase: {
      type: String,
      default: ""
    },
    shareButtonHide: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    display_locale_text: "",
    twitterFollowIcon: require("./assets/ph_sns_x_w.png"),
    facebookFollowIcon: require("./assets/ph_sns_fb_w.png"),
    instagramFollowIcon: require("./assets/ph_sns_insta_w.png"),
    youtubeFollowIcon: require("./assets/ph_sns_yt_w.png"),
    tiktokFollowIcon: require("./assets/tiktok_logo_white.png")
  }),
  mounted: function() {
    this.display_locale_text = this.locale.replace("-", "_");
  },
  methods: {
    changeLocale: function(locale) {
      let toPath = "/" + locale;
      let pathElements = location.pathname.split("/");
      let params = location.search;
      pathElements.forEach(function(pathElement, index) {
        if (index <= 1) {
          return true;
        }
        toPath = toPath + "/" + pathElement;
      });
      toPath = toPath + params;
      location.href = toPath;
      return false;
    }
  }
};
</script>

<style module>
.blandButton {
  vertical-align: middle;
}

.shareIcon {
  width: 40px;
  vertical-align: middle;
}

.footerList {
  list-style: none;
}

.footerListItem {
  text-decoration: none;
}

.footerListItem:hover {
  text-decoration: underline;
  color: #ffffff;
}

.followIconSize {
  width: 32px;
  height: 32px;
}

.followIconSize:hover {
  opacity: 0.5;
}
</style>
